import get from './get'
import set from './set'
import update from './update'
import remove from './remove'

export default {
  ...get,
  ...set,
  ...update,
  ...remove
}
